import Styles from "./Styles/ErrorPayment.module.css";

import { Link } from "react-router-dom";

const ErrorPayment = () => {
  return (
    <div className={Styles.container}>
      <h2>خطایی در پرداخت رخ داد</h2>
      <Link to="/">صفحه اصلی</Link>
    </div>
  );
};

export default ErrorPayment;
